export default __webpack_public_path__ + "static/media/01_Remiseweg_2-nieuwe situatie.f1605e79.jpg";